import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CSVLink } from 'react-csv';
import { Typography, IconButton } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import Link from 'next/link';

import Listings from '../../../utility/Listings';
import Tooltip from '../../../utility/Tooltip';
import ToriiBotDialog from '../../../utility/ToriiBotDialog';
import { addressString } from '../../../../lib/helpers';
import CompsEmptyBlock from './CompsEmptyBlock';
import { compsChomperText } from './constants';
import { media } from '../../../../styles/base';

import style from '../../../../styles/sass/components/CompsChomper.module.scss';
import { isMobile } from '../../../../lib/getDeviceSize';

const styles = {
  button: {
    height: 20,
    left: 5,
    padding: 0,
    top: 0,
    width: 20,
  },
  card: {
    backgroundColor: '#fff',
    margin: '0 auto',
    marginBottom: 0,
    width: '100%',
  },
  cardWrapper: {
    marginBottom: 120,
    marginTop: 20,
    width: '100%',
  },
  icon: {
    height: 17,
    width: 17,
  },
  spaceBetween: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 15px',
  },
  infoTitle: {
    color: '#0e1217',
    fontSize: 16,
    fontWeight: 'bold' as 'bold',
  },
};

export interface Props {
  classes: any;
  comps: any[];
  listing: any;
  onListingSelect: Function;
  selectedListings: any[];
}

interface State {
  showToolTip: boolean;
}

export class CompsContent extends React.Component<Props, State> {
  state = {
    showToolTip: false,
  };
  showToolTip = () => {
    this.setState({
      showToolTip: true,
    });
  };
  hideToolTip = () => {
    this.setState({
      showToolTip: false,
    });
  };

  compsToolTipMessage = () => {
    return (
      <Typography style={{ color: '#0E1217', fontSize: 18, lineHeight: 30 }}>
        Comparable properties, or “Comps,” are homes located in the same area
        and very similar in size, condition and features as the home you are
        trying to buy.
        <br />
        <br />
        Comps are very helpful when deciding what price to offer on a home, and
        sellers use comps to figure out how to best price their home for the
        market.
      </Typography>
    );
  };
  render() {
    const { classes, comps, listing, selectedListings } = this.props;
    let compsLengthToDisplay: string = `${comps.length}`;
    if (selectedListings.length < comps.length) {
      compsLengthToDisplay = `${selectedListings.length}/${comps.length}`;
    }
    return (
      <div className={classes.cardWrapper}>
        {comps.length > 0 ? (
          <React.Fragment>
            {isMobile() ? (
              <div className={classes.spaceBetween}>
                <Typography className={classes.infoTitle}>
                  Comparable Properties
                  <IconButton
                    onClick={this.showToolTip}
                    classes={{ root: classes.button }}
                  >
                    <Help className={classes.icon} />
                  </IconButton>
                </Typography>
                <Typography className={classes.infoTitle}>
                  {selectedListings.length}/{comps.length}
                </Typography>
              </div>
            ) : (
              <div style={{ marginBottom: 10 }}>
                <span className={style.comparablePropertiesTitle}>
                  Comparable Properties ({compsLengthToDisplay}){' '}
                  <span
                    style={{
                      position: 'absolute',
                      right: -20,
                      top: -15,
                      width: 'fit-content',
                    }}
                  >
                    <Tooltip text={compsChomperText} />
                  </span>
                </span>
              </div>
            )}
            <React.Fragment>
              <p className={style.unlockInfo}>
                Uncheck properties to exclude from your results above
              </p>
              {!isMobile() && (
                <div style={{ marginBottom: 25, marginTop: 20 }}>
                  <CSVLink
                    data={selectedListings}
                    filename={`Torii Comps - ${addressString(
                      listing,
                      true,
                    )}.csv`}
                    target="_blank"
                  >
                    <img
                      style={{ height: 12, width: 12 }}
                      data-alt="download"
                      src="/static/img/DL.svg"
                    />{' '}
                    Download .csv
                  </CSVLink>
                </div>
              )}
              <Listings
                allowFavorite={false}
                listings={comps}
                narrow={false}
                onListingSelect={this.props.onListingSelect}
                selectedListings={this.props.selectedListings}
                showDelete={false}
                isComps
              />
            </React.Fragment>
          </React.Fragment>
        ) : (
          <CompsEmptyBlock classes={classes} />
        )}
        {isMobile() && (
          <ToriiBotDialog
            content={this.compsToolTipMessage()}
            isOpen={this.state.showToolTip}
            handleClose={this.hideToolTip}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(CompsContent);
